var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_294",
    "data-name": "Grupo 294",
    transform: "translate(-1160.358 -451.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1393",
    "data-name": "Rect\\xE1ngulo 1393",
    d: "M20,0h0a0,0,0,0,1,0,0V38a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z",
    transform: "translate(1164.358 451.612)",
    fill: "#e05353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1394",
    "data-name": "Rect\\xE1ngulo 1394",
    d: "M0,0H0A20,20,0,0,1,20,20V38a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1184.358 451.612)",
    fill: "#ad0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1395",
    "data-name": "Rect\\xE1ngulo 1395",
    width: 24,
    height: 13,
    transform: "translate(1160.358 489.612)",
    fill: "#578fe7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1396",
    "data-name": "Rect\\xE1ngulo 1396",
    width: 24,
    height: 13,
    transform: "translate(1184.358 489.612)",
    fill: "#3f63be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "priority_high_black_24dp",
    transform: "translate(1169.723 458.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1170",
    "data-name": "Trazado 1170",
    d: "M0,0H29.271V29.271H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_31",
    "data-name": "Elipse 31",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(11.636 20.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1171",
    "data-name": "Trazado 1171",
    d: "M10,3h4.879V17.636H10Z",
    transform: "translate(2.196 0.659)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e3bcea87c6451ec68d6334799d0c40d5.svg";
export { ForwardRef as ReactComponent };